import { createSlotRecipe } from './runtime';

const toastConfig = {"name":"toast","slots":["group","root","title","description","actionTrigger","closeTrigger"]}

export const toast = /* @__PURE__ */ createSlotRecipe(toastConfig)